import Button from '../../../../../../components/Assets/Button';
import styles from './adDetailsForms.module.scss';

interface IValidationButtonProps {
  label?: string;
}
function ValidationButton({ label }: IValidationButtonProps) {
  return (
    <Button
      btnType="submit"
      btnContent={label ?? 'LANCER LA RECHERCHE'}
      primary
      className={styles.validButton}
    />
  );
}

export default ValidationButton;
